/**
 * Communication bridge between content-editor (inner iframe)
 * and the PPT wrapper / React parent (outer window).
 */

import { CONFIG } from './config'
import { log } from './utils'

export type MessageHandler = (payload: Record<string, unknown>) => void

export class MessageBridge {
  private listeners = new Map<string, MessageHandler>()

  constructor() {
    this.setupListener()
  }

  private setupListener(): void {
    window.addEventListener('message', (event: MessageEvent) => {
      if (!event.data || event.data.source !== 'musk-editor-parent') return

      const { type, payload } = event.data as { type: string, payload: Record<string, unknown> }
      const handler = this.listeners.get(type)

      if (handler) {
        try {
          handler(payload)
        } catch (error) {
          console.error(`[Musk Editor] 处理消息失败 [${type}]:`, error)
        }
      }
    })

    log('通信桥接已建立')
  }

  send(type: string, payload: Record<string, unknown>): void {
    try {
      window.parent.postMessage({
        source: 'musk-editor',
        type,
        payload,
        timestamp: Date.now(),
      }, CONFIG.PARENT_ORIGIN)
    } catch (error) {
      console.error('[Musk Editor] 发送消息失败:', error)
    }
  }

  on(type: string, handler: MessageHandler): void {
    this.listeners.set(type, handler)
  }

  off(type: string): void {
    this.listeners.delete(type)
  }
}
